import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Sempre buscar dados frescos
      retry: 2,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: false, // Realtime substitui polling
    },
  },
});
